import { breakpoints } from './vendor/breakpoints.min.js';
import { browser } from './vendor/browser.min.js';
import Scrollbar from 'smooth-scrollbar';
import Helpers from './helpers';
import Header from './header';
import Footer from './footer';
import Player from './player';
import slick from 'slick-carousel/slick/slick';
import 'waypoints/lib/jquery.waypoints.js';

let hiaScrollbar;

var Main = {
	el: {
		scrollTo: jQuery('.scroll-to'),
		gotoDot: jQuery('#goto-pager .goto-dot'),
		openclose: jQuery('.openclose'),
		tabs: jQuery('#product-tabs .tab'),
		tabContent: jQuery('#tab-contents .tab-cont'),
		searchHandler: jQuery('#search-handler'),
		searchDropdown: jQuery('#search-dropdown'),
		searchField: jQuery('#search-dropdown .search-field'),
		searchClose: jQuery('#search-close'),
		searchResultBlock: jQuery('.search-result-block'),
		showOnLoad: jQuery('.show-on-load'),
		body: jQuery('body'),
	},
	vars: {
		windowW:
			window.innerWidth ||
			document.documentElement.clientWidth ||
			document.body.clientWidth,
		windowH:
			window.innerHeight ||
			document.documentElement.clientHeight ||
			document.body.clientHeight,
	},
	init: function() {
		// console.log('%cdev: www.href.gr ', 'background: #222; color: #fefefe');

		console.log('%cDesign & Code: href.gr', 'color: #fff; display: block; font-weight:bold; background-color:#242532; padding: 12px 10px;');

		window.slick = require('slick-carousel');



		// Breakpoints.
		breakpoints({
			default: ['1681px', null],
			xlarge: ['1281px', '1680px'],
			large: ['981px', '1280px'],
			medium: ['737px', '980px'],
			small: ['481px', '736px'],
			xsmall: ['361px', '480px'],
			xxsmall: [null, '360px'],
		});

		// // Play initial animations on page load.
		// window.on('load', function() {
		// 	window.setTimeout(function() {
		// 		jQuery('body').removeClass('is-preload');
		// 	}, 100);
		// });

		// Hack: Enable IE workarounds.
		if ('ie' == browser.name) jQuery('body').addClass('is-ie');

		// Mobile?
		if (browser.mobile) jQuery('body').addClass('is-mobile');


		window.setTimeout(function() {
			Main.el.body.removeClass('is-preload');
		}, 100);

		Main.vendorScripts();
	},
	vendorScripts: function() {
		const helpers = new Helpers();
		const header = new Header();

		const footer = new Footer();

		const player = new Player();

		// hiaScrollbar = Scrollbar.init(document.querySelector('#hia-content'));
		// hiaScrollbar.addListener(s => {
		// 	// console.log('s ->>> ', s);
		// 	if (30 < s.offset.y && !jQuery('body').hasClass('sticky')) {
		// 		jQuery('body').addClass('sticky');
		// 		Header.prototype.isSticky = true;
		// 		header.animateHeader();
		// 	} else if (30 >= s.offset.y && jQuery('body').hasClass('sticky')) {
		// 		jQuery('body').removeClass('sticky');
		// 		Header.prototype.isSticky = false;
		// 		header.animateHeader();
		// 	}
		// });

		// console.log('s ->>> ', s);
		jQuery(window).scroll(function() {
			this.setTimeout(function() {
				let offset = jQuery(window).scrollTop();
				if (30 <= offset && !jQuery('body').hasClass('sticky')) {
					jQuery('body').addClass('sticky');
					Header.prototype.isSticky = true;
					header.animateHeader();
				} else if (30 >= offset && jQuery('body').hasClass('sticky')) {
					jQuery('body').removeClass('sticky');
					Header.prototype.isSticky = false;
					header.animateHeader();
				}
			}, 100);
		});

		jQuery('.footer__top .arrow').on('click', function(e) {
			e.preventDefault();
			// window.scroll({ top: 0, left: 0, behavior: 'smooth' });
			// console.log('top >>> ', hiaScrollbar.scrollTop);
			hiaScrollbar.scrollTo(0, 0, 600);
		});

		Raven.config(
			'https://ea089c3b498743ccb151b9f4ed1ce4e4@sentry.io/5303478',
		).install();

		// CURSOR ++++++++++
		// document
		// 	.getElementsByTagName('body')[0]
		// 	.addEventListener('mousemove', function(n) {
		// 		(t.style.left = n.clientX + 'px'),
		// 		(t.style.top = n.clientY + 'px'),
		// 		(e.style.left = n.clientX + 'px'),
		// 		(e.style.top = n.clientY + 'px'),
		// 		(i.style.left = n.clientX + 'px'),
		// 		(i.style.top = n.clientY + 'px');
		// 	});
		// let t = document.getElementById('cursor'),
		// 	e = document.getElementById('cursor2'),
		// 	i = document.getElementById('cursor3');
		// function n(t) {
		// 	e.classList.add('hover'), i.classList.add('hover');
		// }
		// function s(t) {
		// 	e.classList.remove('hover'), i.classList.remove('hover');
		// }
		// s();
		// for (
		// 	let r = document.querySelectorAll('.hover-target'), a = r.length - 1;
		// 	0 <= a;
		// 	a--
		// ) {
		// 	o(r[a]);
		// }
		// function o(t) {
		// 	t.addEventListener('mouseover', n), t.addEventListener('mouseout', s);
		// }
		// let progressPath = document.querySelector('.progress-wrap path');
		// let pathLength = progressPath.getTotalLength();
		// progressPath.style.transition = progressPath.style.WebkitTransition =
		// 	'none';
		// progressPath.style.strokeDasharray = pathLength + ' ' + pathLength;
		// progressPath.style.strokeDashoffset = pathLength;
		// progressPath.getBoundingClientRect();
		// progressPath.style.transition = progressPath.style.WebkitTransition =
		// 	'stroke-dashoffset 10ms linear';
		// let updateProgress = function() {
		// 	let scroll = jQuery(window).scrollTop();
		// 	let height = jQuery(document).height() - jQuery(window).height();
		// 	let progress = pathLength - (scroll * pathLength) / height;
		// 	progressPath.style.strokeDashoffset = progress;
		// };
		// updateProgress();
		// jQuery(window).scroll(updateProgress);
		// CURSOR ++++++++++

		// if (jQuery('.iso').length) {
		//   var jQuerygrid = jQuery('.iso').isotope({
		//     itemSelector: '.iso-item',
		//     layoutMode: 'fitRows'
		//   });
		//   // filter items on button click
		//   jQuery('.filter-button-group').on( 'click', 'a', function() {
		//     var filterValue = jQuery(this).attr('data-filter');
		//     jQuery(this).toggleClass('selected').siblings().removeClass('selected');
		//     jQuerygrid.isotope({ filter: filterValue });
		//   });
		// }

		jQuery('#project__more').click(function(e) {
			jQuery(this).toggleClass('opened');
			jQuery('.post__texts').toggleClass('collapsed');
			jQuery('.post__details').toggleClass('collapsed');
		});

		// jQuery(".menu--primary > ul").metisMenu();

		jQuery('.section--slider')
			.not('.slick-initialized')
			.slick({
				slidesToShow: 1,
				// slidesToScroll: 1,
				autoplay: true,
				autoplaySpeed: 3000,
				dots: false,
				arrows: false,
				infinite: true,
				centerMode: true,
				centerPadding: '0px',
				fade: true,
				cssEase: 'linear',
				rows: 0,
				pauseOnFocus: false,
				pauseOnHover: false,
			})
			.on('afterChange', function(slick, currentSlide) {
				let imageUrl = jQuery('.slick-active')
					.css('background-image')
					.replace('url("', '')
					.replace('")', '');
				console.log('imageUrl', imageUrl);
				helpers.getImageLightness(imageUrl).then(brightness => {
					// 0 (darkest) and 255 (brightest)
					if (128 < brightness) {
						jQuery('body').addClass('bright');
					} else {
						jQuery('body').removeClass('bright');
					}
					// console.log('brightness ' + brightness);
				});
			});


		jQuery('.slider__projects').not('.slick-initialized').slick({
			slidesToShow: 3,
			slidesToScroll: 1,
			autoplay: true,
			autoplaySpeed: 1700,
			dots: false,
			arrows: true,
			infinite: true,
			centerMode: false,
			// variableWidth: true,
			centerPadding: '0px',
			rows: 0,
			pauseOnFocus: false,
			pauseOnHover: true,
			prevArrow: '<div class="artist__arrow artist__arrow--prev"></div>',
			nextArrow: '<div class="artist__arrow artist__arrow--next"></div>',
			responsive: [{
				breakpoint: 600,
				settings: {
					dots: false,
					arrows: false,
					infinite: true,
					slidesToShow: 1,
					slidesToScroll: 1,
					pauseOnFocus: false,
					pauseOnHover: false
				}
			},
			{
				breakpoint: 800,
				settings: {
					dots: false,
					arrows: false,
					infinite: true,
					slidesToShow: 3,
					slidesToScroll: 1,
					pauseOnFocus: false,
					pauseOnHover: true
				}
			}]
		});
		jQuery('.flex-next').click(function() {
			jQuery('.slider__projects').slick('slickNext')
		});
		jQuery('.flex-prev').click(function() {
			jQuery('.slider__projects').slick('slickPrev')
		});
		// let filtered = false;
		// jQuery('.js-filter').on('click', function(){
		// 	let slug = jQuery(this).attr('data-slug');
		//
		// 	if (false === filtered && undefined !== slug) {
		// 		// console.log('slug', slug);
		// 		jQuery('.slider__projects').slick('slickFilter', slug);
		// 		// jQuery(this).text('Unfilter Slides');
		// 		filtered = true;
		// 	} else {
		// 		jQuery('.slider__projects').slick('slickUnfilter');
		// 		// jQuery(this).text('Filter Slides');
		// 		filtered = false;
		// 	}
		// });

		// var waypoints = jQuery('#header').waypoint(function(direction) {
		//   jQuery('#header').toggleClass('fixed-header');
		// });

		jQuery('.header-menu__toggle').click(function(e) {
			e.preventDefault();
			jQuery('#off-canvas').toggleClass('off-canvas--open');
			jQuery('body').toggleClass('off-canvas-is--open');
		});

		jQuery('.hamburger').click(function(e) {
			header.toggleMenu();
		});

		jQuery('.off-canvas__button').click(function(e) {
			e.preventDefault();
			jQuery('#off-canvas').toggleClass('animate');
		});

		// jQuery('.menu__item').click(function(e) {
		// 	jQuery(this)
		// 		.children('.menu__list--level-1')
		// 		.slideToggle();
		// });

		// jQuery(window).scroll(function() {
		// 	if (!jQuery('#header___button').hasClass('open')) {
		// 		if (200 < jQuery(window).scrollTop()) {
		// 			jQuery('header').addClass('fixed-header');
		// 		} else {
		// 			jQuery('header').removeClass('fixed-header');
		// 		}
		// 	}
		// });

		jQuery(
			'.header__menu menu__list--level-0 > menu__item--has-children',
		).click(function(e) {
			e.preventDefault();
		});

		jQuery('.mobile__menu').click(function(e) {
			if (jQuery(this).hasClass('open')) {
				jQuery('.mobile__menu').toggleClass('open');
				jQuery('.menu__animation').toggleClass('animate');
				jQuery('.header__modalmenu').height('0px');
				jQuery('#header___menu').css({
					position: 'relative',
				});

				if (100 <= jQuery(window).scrollTop()) {
					jQuery('header').addClass('fixed-header');
				} else {
					jQuery('header').removeClass('fixed-header');
				}
			} else {
				jQuery('.mobile__menu').toggleClass('open');
				jQuery('.menu__animation').toggleClass('animate');
				jQuery('.header__modalmenu').height('100%');
				jQuery('#header___menu').css({
					position: 'fixed',
				});
			}
		});

		jQuery(document).keydown(function(e) {
			// ESCAPE key pressed
			if (27 === e.keyCode) {
				if (jQuery('.header__search').hasClass('open')) {
					jQuery('.header__search').toggleClass('open');
					jQuery('.menu__animation').toggleClass('animate');
					jQuery('.header__modalsearch').height('0px');
				}

				if (jQuery('.header__menu').hasClass('open')) {
					jQuery('.mobile__menu').toggleClass('open');
					jQuery('.menu__animation').toggleClass('animate');
					jQuery('.header__modalmenu').height('0px');
					jQuery('.mobile__menu__menu').css({
						position: 'relative',
					});

					if (100 <= jQuery(window).scrollTop()) {
						jQuery('header').addClass('fixed-header');
					} else {
						jQuery('header').removeClass('fixed-header');
					}
				}
			}
		});

		jQuery('#search-close').click(function(e) {
			if (jQuery('.header__search').hasClass('open')) {
				jQuery('.header__search').toggleClass('open');
				jQuery('.menu__animation').toggleClass('animate');
				jQuery('.header__modalsearch').height('0px');
			}
		});

		jQuery('.show-in-view').each(function() {
			new Waypoint({
				element: this,
				handler: function(i) {
					'down' === i
						? jQuery(this.element).addClass('animate')
						: jQuery(this.element).removeClass('animate');
				},
				offset: '95%',
			});
		});

		jQuery('.artist__toggle').click(function(e) {
			e.preventDefault();
			jQuery(this).toggleClass('artist__toggle--open');
			// jQuery('.artist__text').slideDown();
			jQuery('.artist__text').toggleClass('artist__text--closed');
			jQuery('.artist__text').toggleClass('opened');
		});
	},
	resizing: function() {
		Main.vars.windowW = jQuery(window).width();
	},
	orientationChange: function() {

		console.log('screen.orientation::', screen.orientation);

		if ('landscape-primary' === screen.orientation.type && Main.el.body.hasClass('is-mobile')) {
			Main.el.body.removeClass('portrait');
			Main.el.body.addClass('landscape');
		} else {
			Main.el.body.addClass('portrait');
			Main.el.body.removeClass('landscape');
		}

	},
};

jQuery(window).load(function() {
	Main.init();
}),
onresize = Main.resizing,
window.addEventListener('orientationchange', Main.orientationChange);

export default Main;
